import ActionType from 'actions/ActionType'

export default (state = 0, action) => {
  const switchObj = {
    // [ActionType.SignupForm.SELECT_FORM_TYPE]: () => {
    //   if (action.payload === 'signup') {
    //     return 0
    //   }

    //   if (action.payload === 'custom') {
    //     return 0
    //   }

    //   return state
    // },
    [ActionType.SignupForm.TOGGLE_FORM_DATA_PANEL]: () => {
      return action.payload
    },
    // [ActionType.SignupForm.VALIDATION_FAILURE]: () => {
    // 	const dup = state
    // 	const pathStateMap = {
    // 		'.name': 0,
    // 		'.title.color': 1,
    // 		'.title.text': 1,
    // 		'.description.color': 1,
    // 		'.description.text': 1,
    // 		'.display_type': 1,
    // 		'.button.text': 5,
    // 		'.button.text_color': 5,
    // 		'.button.background_color': 5,
    // 		'.text_color': 3,
    // 		'.font': 3,
    // 		'.background_color': 4,
    // 	}

    // 	action.errors.forEach((error) => {
    // 		dup[pathStateMap[error.dataPath]] = true
    // 	})

    // 	return dup
    // },
  }

  // If the function returns falsey, a ternary is required because
  // if `|| state` is used, state will remain the same
  return switchObj?.[action?.type] ? switchObj[action?.type]() : state
}
